import { AbstractControl } from "@angular/forms";
import * as _ from 'lodash'
export class ValidationService {
    static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
        // console.log(validatorName);
        let config: any = {
            'required': 'Required',
            'invalidCreditCard': 'Is invalid credit card number',
            'invalidEmailAddress': 'Invalid email address',
            'invalidPassword': 'Invalid password. Password must be at least 6 characters long, and contain a number.',
            'minlength': `Minimum length ${validatorValue.requiredLength}`,
            'invalidNumber':'Value must be number'
        };

        return config [validatorName];
    }

    static creditCardValidator(control :any) {
        // Visa, MasterCard, American Express, Diners Club, Discover, JCB
        if (control.value && control.value.match(/^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/)) {
            return null;
        } else {
            return { 'invalidCreditCard': true };
        }
    }

    static emailValidator(control :any) {
        // RFC 2822 compliant regex
        if (control.value && control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
            return null;
        } else {
            return { 'invalidEmailAddress': true };
        }
    }

    static numberValidator(control :any) {
        // RFC 2822 compliant regex
        console.log('i am called');
        if (control.value && control.value.match(/[0-9]*/)) {
            return null;
        } else {
            return { 'invalidNumber': true };
        }
    }

    static passwordValidator(control:any) {
        // {6,100}           - Assert password is between 6 and 100 characters
        // (?=.*[0-9])       - Assert a string has at least one number
        if (control.value && control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{6,100}$/)) {
            return null;
        } else {
            return { 'invalidPassword': true };
        }
    }

    static phoneNumberValidator(control: AbstractControl): { [key: string]: boolean } | null {
        try {
            let cellNumber = control.value
            let state = -1;
            let invalidList = ["0", "1", "2", "3", "4", "5"];
            let validList = ["6", "7", "8", "9"];

            if (_.isNumber(cellNumber)) {
                cellNumber = String(cellNumber);
            }
            if (!_.isNaN(parseInt(cellNumber))) {
                state = 1;
            }
            if (cellNumber.length == 10) {
                if (state == 1) {
                    state = 2;
                }
            }
            if (invalidList.indexOf(cellNumber.substr(0, 1)) == -1) {
                if (state == 2) {
                    state = 3;
                }
            }
            if (validList.indexOf(cellNumber.substr(0, 1)) != -1) {
                if (state == 3) {
                    state = 4;
                }
            }

            if (state !== 4) {
                return { 'validPhone': true };
            }
        } catch (error) {
            return { 'validPhone': true };
        }
    }

    static noWhitespaceValidator(control: AbstractControl) {
        let isWhitespace = (control.value || '').toString().trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { 'whitespace': true };
    }
}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/shared/utilities/validation.service.ts